import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CHANGE_PSW_URL } from 'constants/Environment';
import Literal from 'components/literal';
import './styles.scss';

const PasswordField = ({
    dataTest = '',
    showPassword,
    input,
    toggleShowPassword = () => null,
    label = '',
}) => {
    const inputType = useMemo(() => (showPassword ? 'text' : 'password'), [showPassword]);
    const btnIconClass = useMemo(
        () => `${showPassword ? 'cfm-ic-eye-off' : 'cfm-ic-eye'}`,
        [showPassword],
    );

    return (
        <div className="form-group password-field">
            <label>{label}</label>
            <a href={CHANGE_PSW_URL} className="login__forgot-password" tabIndex="-1">
                <Literal literal="cfm_action_forgot_pass" />
            </a>
            <div className="input-group">
                <input
                    className="form-control"
                    type={inputType}
                    {...input}
                    data-test={dataTest}
                    autoFocus
                />
                <div className="input-group-append">
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={toggleShowPassword}
                    >
                        <i className={btnIconClass} />
                    </button>
                </div>
            </div>
        </div>
    );
};

PasswordField.propTypes = {
    dataTest: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.shape({}).isRequired,
    showPassword: PropTypes.bool,
    toggleShowPassword: PropTypes.func,
};

export default PasswordField;
